// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"b4435608","144":"298a55c6","210":"b527cebe","277":"0c704dad","292":"0c704dad","404":"389b7daa","433":"0c704dad","537":"0c704dad","877":"744d8349"}[chunkId] + ".chunk.css";
};